export default __webpack_public_path__ + "static/21-245e9cf50258766847c1c239f2492bbb.webp";